import { useContext } from "react";
import { LangContext } from "../../Context/Langcontext";

const DataServiceList = () => {
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  return {
    landbase: [
      { title: lang.LandmarkPoint, endpoint: "landmark-points" },
      { title: lang.DistrictPoly, endpoint: "district-polys" },
      { title: lang.LandmarkLine, endpoint: "landmark-lines" },
      { title: lang.CenterLine, endpoint: "center-lines" },
      { title: lang.RoadEdge, endpoint: "road-edges" },
      { title: lang.Building, endpoint: "buildings" },
      { title: lang.BuildingLine, endpoint: "building-lines" },
      { title: lang.Hydrology, endpoint: "hydrologys" },
    ],
    electric: [
      { title: lang.Capacitor, endpoint: "capacitors" },
      { title: lang.cctv, endpoint: "cctvs" },
      { title: lang.DuctBank, endpoint: "duct-banks" },
      { title: lang.FiberOpticCable, endpoint: "fiber-obtic" },
      { title: lang.Fuse, endpoint: "fuses" },
      { title: lang.Ground, endpoint: "grounds" },
      { title: lang.GroundMeter, endpoint: "group-meters" },
      { title: lang.HighTensionMeter, endpoint: "high-tension-meters" },
      { title: lang.InlineEquipment, endpoint: "inline-equipments" },
      { title: lang.LightningArrestor, endpoint: "lightning-arrestors" },
      { title: lang.LowVoltageMeter, endpoint: "low-voltage-meters" },
      { title: lang.Manhole, endpoint: "manholes" },
      { title: lang.Meterline, endpoint: "meter-lines" },
      { title: lang.Meterlink, endpoint: "meter-links" },
      { title: lang.OverheadHighVoltageConductor, endpoint: "ohhv-conductors" },
      { title: lang.OverheadLowVoltageConductor, endpoint: "ohlv-conductors" },
      {
        title: lang.OverheadLowVoltageConductorUnder,
        endpoint: "ohlv-conductor-under-buildings",
      },
      {
        title: lang.OverheadMediumVoltageConductor,
        endpoint: "ohmv-conductors",
      },
      {
        title: lang.OverheadStreetlightVoltageConductor,
        endpoint: "ogsl-conductors",
      },
      { title: lang.Pole, endpoint: "poles" },
      { title: lang.SpanGuy, endpoint: "span-guys" },
      { title: lang.Splice, endpoint: "splices" },
      { title: lang.Streetlight, endpoint: "streetlights" },
      { title: lang.StreetlightControl, endpoint: "streetlight-controls" },
      { title: lang.Switche, endpoint: "switches" },
      { title: lang.Transformer, endpoint: "transformers" },
      {
        title: lang.UndergroundHighVoltageConductor,
        endpoint: "ughv-conductors",
      },
      {
        title: lang.UndergroundLowVoltageConductor,
        endpoint: "uglv-conductors",
      },
      {
        title: lang.UndergroundMediumVoltageConductor,
        endpoint: "ugmv-conductors",
      },
      {
        title: lang.UndergroundStreetlightVoltageConductor,
        endpoint: "ugsl-conductors",
      },
      {
        title: lang.Streetlightinlineequipment,
        endpoint: "sl-inline-equipments",
      },
      { title: lang.Circuitbreaker,
        endpoint: "circuit-breakers" },
      { title: lang.Riser,
        endpoint: "risers" },
      { title: lang.SubstationTransformer,
        endpoint: "sub-transformers" },
      { title: lang.Switchgear,
        endpoint: "switchgears" },                              
    ],
    layergroup: [
      {
        title: lang.FiberOpticSystem,
        endpoint: "electrical-system-fiber-optics",
      },
      { title: lang.PublicSystem, endpoint: "electrical-system-publics" },
      { title: lang.OnGroundSystem, endpoint: "electrical-system-ongrounds" },
      {
        title: lang.UndergroundSystem,
        endpoint: "electrical-system-undergrounds",
      },
      { title: lang.Landbase, endpoint: "landbases" },
    ],
  };
};

export default DataServiceList;
